/**
 * Меню открыто внутри iframe на чужом сайте (виджет на сайте заведения).
 *
 * Во встроенном режиме нельзя трогать историю: у вкладки она общая (joint session
 * history), и записи, добавленные фреймом, лежат в ней вместе с записями хоста.
 * WebKit (Safari на iOS) откручивает эту общую историю, поэтому `history.goBack()`
 * из меню уводит назад страницу заведения. Поэтому в embedded-режиме модалки
 * открываются через стор, а переходы делаются через `replace`.
 */
export const isEmbedded = (): boolean => {
    try {
        return window.self !== window.top;
    } catch {
        // Доступ к window.top не должен бросать, но если браузер решит иначе —
        // значит мы точно во вложенном контексте.
        return true;
    }
};
